import React from 'react';

// AuthContext will carry, user info, login and logout methods via
// AuthProvider
const AuthContext = React.createContext({
    user: null, login: () => {}, logout: () => {}
});

export default AuthContext
